/* eslint-disable max-classes-per-file */
import * as Sentry from '@sentry/react';

import { log } from './logging.util';
import { IS_ROCKWEST } from './style.util';
import {
  FILTERED_ERRORS,
  STOP_WORDS,
} from '../constants/error-monitoring.constants';

const handleConstructorParam = (param) => {
  if (param instanceof Error) return String(param);
  return param;
};

const isHTTPError = (error) => !!error.url;

const isErrorChild = (obj) => {
  if (obj instanceof Error) return true;
  if (obj.prototype) {
    isErrorChild(obj.prototype);
  } else {
    return obj instanceof Error;
  }
};
class WError extends Error {
  constructor(payload, url, method, params, status) {
    const msg = handleConstructorParam(payload);
    super(msg);
    if (isHTTPError(payload)) {
      this.url = payload.url;
      this.method = payload.method;
      this.params = payload.params;
      this.status = payload.status;
    } else {
      this.url = url;
      this.method = method;
      this.params = params;
      this.status = status;
    }
  }
}

export class HTTPError extends WError {
  constructor(msg, url, method, params, status) {
    super(msg, url, method, params, status);
    this.name = 'HTTPError';
  }
}
export class IntegrationError extends WError {
  constructor(msg) {
    super(`IntegrationError: ${msg}`);
    this.name = 'IntegrationError';
  }
}
window.isErrorChild = isErrorChild;
window.IntegrationError = IntegrationError;
export class CalculationError extends WError {
  constructor(msg) {
    super(msg);
    this.name = 'CalculationError';
  }
}

export class KYCError extends IntegrationError {
  constructor(msg) {
    super(`KYCError: ${msg}`);
    this.name = 'KYCError';
  }
}
export class SocketError extends WError {
  constructor(msg) {
    super(msg);
    this.name = 'SocketError';
  }
}

export class ChartError extends WError {
  constructor(msg) {
    super(msg);
    this.name = 'ChartError';
  }
}

export class ConnectionError extends SocketError {
  constructor(msg) {
    super(`ConnectionError: ${msg}`);
    this.name = 'ConnectionError';
  }
}

export class BackendError extends WError {
  constructor(msg) {
    super(msg);
    this.name = 'BackendError';
  }
}

export class InfrastructureError extends WError {
  constructor(msg) {
    super(msg);
    this.name = 'InfrastructureError';
  }
}

export class QAError extends WError {
  constructor(msg) {
    super(msg);
    this.name = 'QAError';
  }
}

export class AuthError extends WError {
  constructor(msg) {
    super(msg);
    this.name = 'AuthError';
  }
}

export class PaymentError extends WError {
  constructor(msg) {
    super(msg);
    this.name = 'PaymentError';
  }
}

export class ActivatePSPError extends WError {
  constructor(msg) {
    super(msg);
    this.name = 'ActivatePSPError';
  }
}

export class OpenRealAccountError extends WError {
  constructor(msg) {
    super(msg);
    this.name = 'OpenRealAccountError';
  }
}

export class NotFoundAccountError extends BackendError {
  constructor(msg) {
    super(msg);
    this.name = 'NotFoundAccountError';
  }
}

export class TargetValueError extends WError {
  constructor(msg) {
    super(msg);
    this.name = 'TargetValueError';
  }
}

const reportError = (msg) => {
  Sentry.captureException(new QAError(msg));
  return msg;
};

export const captureError = (err, needToThrow) => {
  let strError = '';
  if (isErrorChild(err)) {
    strError = `${String(err)} ${JSON.stringify(
      err,
      Object.getOwnPropertyNames(err)
    )}`;
  } else {
    strError = err;
  }
  log(strError, 'error');
  if (
    IS_ROCKWEST &&
    !FILTERED_ERRORS.includes(err.message) &&
    !STOP_WORDS.some((word) => strError.includes(word))
  ) {
    Sentry.captureException(err, (scope) => {
      if (isErrorChild(err)) scope.setTag('exceptionType', err.name);
      return scope;
    });
  }
  if (needToThrow) throw err;
};

export const captureMessage = (err) => {
  let strError = '';
  if (isErrorChild(err)) {
    strError = JSON.stringify(err, Object.getOwnPropertyNames(err));
  } else {
    strError = err;
  }
  log(strError, 'comment');
  Sentry.captureMessage(strError, Sentry.Severity.Info);
};

window.reportError = reportError;
